export default __webpack_public_path__ + "886868980af4fdfa7a869ce1e6f084ca.png";